export type TabletOrientationInput = {
  coarsePointer: boolean;
  screenWidth: number;
  screenHeight: number;
  orientationType: string | null;
  orientationAngle: number | null;
  portraitMedia: boolean;
};

export function shouldBlockTabletPortrait(input: TabletOrientationInput) {
  if (!input.coarsePointer) return false;
  const shortestSide = Math.min(input.screenWidth, input.screenHeight);
  if (shortestSide < 600) return false;
  // Landscape-native tablets can report angle 0; emulators can retain a stale type.
  // Screen dimensions remain stable when the on-screen keyboard opens.
  if (input.screenWidth > input.screenHeight) return false;
  if (input.orientationType) return input.orientationType.startsWith("portrait");
  if (input.orientationAngle !== null)
    return input.orientationAngle === 0 || input.orientationAngle === 180;
  if (input.screenWidth > 0 && input.screenHeight > 0)
    return input.screenHeight > input.screenWidth;
  return input.portraitMedia;
}
